var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCropsPremanentPasture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_1302)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42361 32.4667C6.12214 24.9573 14.7978 19.3995 25.1979 19.1155C24.8982 19.1082 24.5973 19.0986 24.294 19.0986C12.7216 19.0986 2.97648 24.7542 0 32.4643L3.42361 32.4667Z",
    fill: "#36975C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38202 32.4667C10.3657 29.1325 12.3174 26.1826 14.9289 23.9095C18.1265 21.1251 22.3139 19.3535 26.9351 19.1263C26.5591 19.1096 26.1828 19.1016 25.8064 19.1021C15.9815 19.1021 7.70707 24.7578 5.17773 32.4679L9.38323 32.4655L9.38202 32.4667Z",
    fill: "#36975C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.71 32.4667C17.3438 25.1603 22.4919 19.6943 28.7313 19.1493C28.3349 19.1168 27.9374 19.0999 27.5397 19.0986C19.826 19.0986 13.3281 24.7542 11.3438 32.4643L15.71 32.4667Z",
    fill: "#36975C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3331 32.4667C23.393 25.3754 27.167 20.1705 31.1671 19.4393C30.7163 19.275 29.5707 19.1928 29.1695 19.1457C23.6383 18.5076 19.0993 24.7578 17.666 32.4643L22.3331 32.4667Z",
    fill: "#36975C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4413 26.6805V22.8315C42.2099 22.6793 42.8129 21.3028 42.8129 19.6097C42.8129 17.8152 42.2087 17.0043 41.3773 17.0043C40.5458 17.0043 39.7954 17.8152 39.7954 19.6097C39.7954 21.2037 40.3295 22.5234 41.028 22.8037V26.1996C40.0198 25.0325 38.9176 23.9501 37.7325 22.9633V18.6333C38.6232 18.4641 39.3204 16.9269 39.3204 15.032C39.3204 13.026 38.292 12 37.6044 12C36.9168 12 35.8279 13.0284 35.8279 15.0332C35.8279 16.8133 36.4443 18.2901 37.2576 18.6007V22.5802C34.756 20.5983 32.3379 19.4224 30.907 19.4224C27.6985 19.4224 24.9855 24.9137 24.084 32.4752L45.0003 32.4691C44.1205 30.3664 42.8625 28.405 41.4413 26.6805Z",
    fill: "#36975C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsPremanentPasture);
export default __webpack_public_path__ + "static/media/ic-crops-premanent-pasture.5279e72c34bb0ddee6396f79b5d940a1.svg";
export { ForwardRef as ReactComponent };